import { render, staticRenderFns } from "./ChangeSubscription.vue?vue&type=template&id=2f21a029&scoped=true&"
import script from "./ChangeSubscription.vue?vue&type=script&lang=js&"
export * from "./ChangeSubscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f21a029",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\camha\\projects\\netcountable-app\\truple\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f21a029')) {
      api.createRecord('2f21a029', component.options)
    } else {
      api.reload('2f21a029', component.options)
    }
    module.hot.accept("./ChangeSubscription.vue?vue&type=template&id=2f21a029&scoped=true&", function () {
      api.rerender('2f21a029', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/accounts/revenuecat/ChangeSubscription.vue"
export default component.exports